import { Input, Component } from '@angular/core';

@Component({
    selector: '[labelTextInput]',
    templateUrl: 'input-text-read-only.component.html',
    styleUrls: ['./input-text-read-only.component.css'],
})


export class InputTextReadOnlyComponent {
  @Input() labelInput: string;
  @Input() valueInput: string;
  @Input() typeLabel: string;
  @Input() checkListValue: any;
  @Input() formControlClass: boolean;
  @Input() classLabel: string;
  @Input() classInput: string;
  @Input() codiceImporto: string;
  @Input() percentuale: number;
  @Input() valoreNum: number;
  @Input() position: string;
  @Input() listValue: string[];
  @Input() errorColor: boolean = false;
  @Input() labelCol: number = 6;
  @Input() valueCol: number = 2;
  randomId: string = this.getRandomId();

getRandomId(length: number = 10): string {
  return crypto.randomUUID();
}

formatNumber(value: number): string {
    return value.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
}

get ariaLabel(): string {
    const numericValue = parseFloat(this.valueInput);
    if (!isNaN(numericValue)) {
        return (numericValue < 0 ? 'meno' : '') + ' ' + this.formatNumber(Math.abs(numericValue));
    } else {
        return this.labelInput;
    }
}

getLabel(value: string){
  if(value && value.length > 0){
    return value.includes('-') ?  value.replace('-', 'meno').replace('€', 'euro') : value.replace('€', 'euro');
  }else return ''
}

}
